import { Route } from 'react-router-dom';
import React from 'react';

export type WizardStepComponentName = 'SiteDetails' | 'CustomerDetails' | 'SystemDetails' | 'MeterSetup';

export type RouteConfig = {
  path: string;
  component: React.ComponentType<any>;
  requiresLogin: boolean;
  // Can be added by components at run-time to pass down through here. Might be worth reconsidering this implementation
  extraProps?: Record<string, any>;
  componentName?: WizardStepComponentName;
} & SubRouteProps;

// Intersect with prop types on components which take child routes
export type SubRouteProps = { routes: RouteConfig[] };

/**
 * Used to generate routes with possible sub-routes.
 *
 * @param route Configuration for this route.
 */
export default function RouteWithSubRoutes(route: RouteConfig) {
  return (
    <Route
      path={route.path}
      render={(props) => (
        // Pass the sub-routes down to keep nesting. Use this wrapper on nth children for the same result.
        <route.component {...props} {...route.extraProps} routes={route.routes} />
      )}
    />
  );
}
